<div [formGroup]="parentForm" *ngIf="isLinkEnabled" class="link-container">
    <a *ngIf="isText1" class="link-text" id="showHideTextLink1"
        [attr.data-testid]="showHideTextControlModel.controlName + '-show-hide-text-link-1'"
        (click)="changeShowHideTextState()">
        {{ showHideTextControlModel.text1.key }}
    </a>
    <sdps-icon *ngIf="isText1" color="active" type="functional" name="chevron-down" size="medium" class="up-down-icon"
        (click)="changeShowHideTextState()">
    </sdps-icon>
    <a *ngIf="!(isText1)" class="link-text" id="showHideTextLink2"
        [attr.data-testid]="showHideTextControlModel.controlName + '-show-hide-text-link-2'"
        (click)="changeShowHideTextState()">
        {{ showHideTextControlModel.text2.key }}
    </a>
    <sdps-icon *ngIf="!(isText1)" color="active" type="functional" name="chevron-up" size="medium" class="up-down-icon"
        (click)="changeShowHideTextState()">
    </sdps-icon>
</div>